import { apiDelete, apiGet } from "api/callApi";
import SmartFolderColumnDropdownWithEditDelete from "components/SmartFolderColumnDropdownWithEditDelete";
import { useEffect, useState } from "react";
import { showAlert } from "utils/helper";
import SmartFolderColumn from "views/AdminSettings/FolderTemplate/AddEditFolder/SmartFolderColumn";

const SmartFolderColumnDropdown = (props) => {
  const {
    onChange = () => {},
    defaultValue,
    newItemLabel = "",
    name,
    setSelectedData = () => {},
    disabledDropdown,
  } = props;
  const [openModalView, setOpenModalView] = useState(false);
  const [data, setData] = useState([]);
  const [rowData, setRowData] = useState();
  const [isEditing, setIsEditing] = useState(false);

  const getData = async (successCallback = () => {}) => {
    try {
      const response = await apiGet(`/v1/reportcolumn`, false);
      setData(response.data);

      successCallback();
    } catch (error) {
      console.log("Error", error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const selectOptions =
    data.map((item) => ({
      id: item.id,
      label: item.columnName,
      systemColumn: item.systemColumn,
    })) || [];

  const handleDropdownChange = (value) => {
    const selectedOption = selectOptions.find((option) => option.id === value);
    const selectedLabel = selectedOption ? selectedOption.id : "";
    onChange(name, selectedLabel);
    setSelectedData(value);
  };

  const reloadData = (data) => {
    getData(setSelectedData(data));
  };

  const onAddNew = () => {
    setOpenModalView(true);
    setIsEditing(false);
  };

  const handleRemove = async (id) => {
    try {
      const response = await apiDelete(`/v1/reportcolumn/${id}`, false);
      reloadData();
      showAlert({ title: "Success", text: response.message, icon: "success" });
    } catch (error) {
      console.log("Error", error);
      showAlert({
        title: "Error",
        text: error.response.data.message,
        icon: "error",
      });
    }
  };
  const handleEdit = async (option) => {
    try {
      setIsEditing(true);
      setOpenModalView(true);
      setRowData(option);
    } catch (error) {
      console.log("Error", error);
    }
  };

  return (
    <>
      <SmartFolderColumnDropdownWithEditDelete
        defaultValue={defaultValue}
        placeholder="Select Column"
        options={selectOptions}
        onChange={handleDropdownChange}
        borderColor="#ED850C"
        disabled={false}
        onAddNew={onAddNew}
        newItemLabel={newItemLabel}
        disabledDropdown={disabledDropdown}
        handleRemove={handleRemove}
        handleEdit={handleEdit}
      />
      {openModalView && (
        <SmartFolderColumn
          setOpenModalView={setOpenModalView}
          openModalView={openModalView}
          reloadData={reloadData}
          rowData={rowData}
          isEditing={isEditing}
          setRowData={setRowData}
        />
      )}
    </>
  );
};

export default SmartFolderColumnDropdown;
